export default "__VITE_ASSET__294582c7__"